import React, {Component} from 'react';
import './UserCard.scss';
import Avatar from '../../assets/img/avatar.png';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import iconsSvg from '../../assets/img/svgLib/iconsSvg';

// TODO
class UserCard extends Component {
    static propTypes = {
      classPrefix: PropTypes.string,
      userInfo: PropTypes.object,
      handleUserMenuItem: PropTypes.func,
      activeMenu: PropTypes.string,
      notices: PropTypes.object,
    }

    constructor(props) {
      super(props);

      // TODO передавать пропсами с родителя в зависимости от роли юзверя

      this.state = {
        notices: {
          messages: 0,
          notifications: 0,
          verification: 0,
          registration: this.props.notices.registration,
        },
        menu: [
          {key: 'lk', val: this.props.userInfo.role === 'admin' ? 'Личный Кабинет' : 'Мои контракты', icon: 'person'},
          {key: 'messages', val: 'Сообщения', icon: 'mail'},
          {key: this.props.userInfo.role === 'admin' ? 'registration' : 'notifications', val: 'Уведомления', icon: 'ring'},
          {key: 'verification', val: 'Выход', icon: 'guard'},
        ],
        menuItemActive: this.props.activeMenu || 'lk',
      };
    }
    componentWillReceiveProps(nextProps) {
      this.setState({
        notices: {
          messages: 0,
          notifications: 0,
          verification: 0,
          registration: nextProps.notices.registration,
        },
        menu: [
          {key: 'lk', val: nextProps.userInfo.role === 'admin' ? 'Личный Кабинет' : 'Мои контракты', icon: 'person'},
          {key: 'messages', val: 'Сообщения', icon: 'mail'},
          {key: nextProps.userInfo.role === 'admin' ? 'registration' : 'notifications', val: 'Уведомления', icon: 'ring'},
          {key: 'verification', val: 'Выход', icon: 'guard'},
        ],
      });
    }

    checkUserInfo = (userInfo) => {
      const {
        name, surename, middleName
      } = userInfo;

      return {
        name: name ?
                name.charAt(0).toUpperCase() + name.slice(1) : '',
        surename: surename ?
                surename.charAt(0).toUpperCase() + surename.slice(1) : '',
        middleName: middleName ?
                middleName.charAt(0).toUpperCase() + middleName.slice(1) : '',
        position: 'Старший Вице-президент',
        company: 'КредитУралБанк',
      };
    }

    handleUserMenu = (event) => {
      const value = event.target.dataset.value;
      if (value === 'verification') {
        sessionStorage.clear();
        window.location.reload();
      }
      event.stopPropagation();
      this.setState({
        menuItemActive: value,
      });

      this.props.handleUserMenuItem(value);
    }

    getNoticeCount = (noticeType) => {
      return noticeType !== 'lk' && this.state.notices[noticeType];
    }

    get userInformation() {
      const {userInfo} = this.props;
      const info = this.checkUserInfo(userInfo);

      return (
        <div className={'userInformation'}>
          <div className={'userAvatar'}>
            <img src={Avatar} alt={''} />
          </div>
          <div className={'userFio'}>
            <div>{info.surename}</div>
            <div>
              <span>{`${info.name} ${info.middleName}`}</span>
            </div>
          </div>
          <div className={'userPosition'}>
            {info.position}
          </div>
          <div className={'userCompany'}>
            {info.company}
          </div>
        </div>
      );
    }

    get menuItems() {
      const {menuItemActive, menu} = this.state;

      return (<div
        className={'userMenu'}
        onClick={this.handleUserMenu} >
        {menu.map((item, i) => {
          return (
            <div
              key={`user_${i}`}
              className={classNames('menuItem', {
                'active': menuItemActive === item.key,
              })}
              data-value={item.key} >
              <div className={'menuItemIcon'} data-value={item.key}>
                {item.icon ? iconsSvg[item.icon] : null}
              </div>
              <div className={'menuItemText'} data-value={item.key}>
                {item.val}
              </div>
              <div className={classNames(
                  {'noRead': this.getNoticeCount(item.key) > 0},
                  'menuItemNotice')}
              data-value={item.key}>
                {this.getNoticeCount(item.key)}
              </div>
            </div>
          );
        })}
      </div>);
    }

    render() {
      const {userInformation, menuItems} = this;
      return (
        <div className={'userCard'}>
          {userInformation}
          {menuItems}
        </div>
      );
    }
}

export default UserCard;



// WEBPACK FOOTER //
// ./src/shared/UserCard/UserCard.js